import React from "react";
const Changes = function Changes(props) {
    var changenum=0
    return (
        <div className="section">
            <h2 className="title is-2">Change Summary </h2>
            <p className="title is-4">
            <strong>Version 17.0.0</strong>
            <br />
            <strong>April 1, 2026</strong>
            </p>
            <br />

            <p><strong>{++changenum}. New Course Codes</strong></p>
            <p className="changelist">
            028001 - CAMBRIDGE MEDIA ARTS STUDIES (AS LEVEL)
            <br/>028002 - CAMBRIDGE ART AND DESIGN (AS LEVEL)
            <br/>033007 - AP BUSINESS WITH PERSONAL FINANCE
            <br/>060200 - FILL - FACILITATED INTERDEPENDENT LANGUAGE LEARNING
            <br/>060218 - FRENCH FOR FRENCH SPEAKERS I
            <br/>060219 - FRENCH FOR FRENCH SPEAKERS II
            <br/>060220 - FRENCH FOR FRENCH SPEAKERS III
            <br/>150831 - AP AFRICAN AMERICAN STUDIES
            <br/>158005 - CAMBRIDGE MIDDLE SCHOOL GLOBAL PERSPECTIVES
            <br/>158006 - CAMBRIDGE MIDDLE SCHOOL HUMANITIES
            <br/>270713 - AP CYBERSECURITY
            <br/>278001 - CAMBRIDGE MIDDLE SCHOOL COMPUTING
            </p>
            <br />

            <p><strong>{++changenum}. Course Codes with Name Changes</strong></p>
            <p className="changelist">
            017000 - LEADERSHIP & CAREER READINESS WITH WORK-BASED LEARNING (previously AG, FOOD, AND NAT RES LEAD, CAREER READINESS AND WBL EXPER)
            <br/>020100 - HIGH SCHOOL VISUAL ARTS I (previously VISUAL ARTS I)
            <br/>020200 - HIGH SCHOOL VISUAL ARTS II (previously VISUAL ARTS II)
            <br/>020300 - HIGH SCHOOL VISUAL ARTS III (previously VISUAL ARTS III)
            <br/>020800 - ART - MIDDLE SCHOOL/JUNIOR HIGH I (previously ART - MIDDLE SCHOOL/JUNIOR HIGH II)
            <br/>058004 - CAMBRIDGE ADVANCED GLOBAL PERSPECTIVES & RESEARCH (AS LEVEL) (previously CAMBRIDGE ADVANCED GLOBAL PERSPECTIVES AND RESEARCH (AS LEVE))
            <br/>080116 - DANCE SURVEY (previously INTRODUCTION TO DANCE)
            <br/>090134 - BEST PRACTICES IN EARLY CHILD ED WITH WORK-BASED LEARNING (previously BEST PRACTICES IN EARLY CHILDHOOD EDUCATION WITH WBL)
            <br/>120100 - MIDDLE SCHOOL GENERAL MUSIC (previously MUSIC – GENERAL)
            <br/>120450 - HIGH SCHOOL VOCAL ENSEMBLE (previously VOCAL ENSEMBLE)
            <br/>120452 - HIGH SCHOOL CONTEMPORARY VOCAL ENSEMBLE (previously CONTEMPORARY VOCAL ENSEMBLE)
            <br/>120505 - HIGH SCHOOL CONCERT AND MARCHING BAND (previously CONCERT AND MARCHING BAND)
            <br/>120551 - HIGH SCHOOL CONTEMPORARY INSTRUMENTAL ENSEMBLE (previously CONTEMPORARY INSTRUMENTAL ENSEMBLE)
            <br/>350002 - BEST PRACTICES IN ED AND TRAINING WITH WORK-BASED LEARNING (previously BEST PRACTICES IN EDUCATION AND TRAINING WITH WBL)
            </p>
            <br />

            <p><strong>{++changenum}. Course Codes with Name and Description Changes</strong></p>
            <p className="changelist">
            060003 - ARABIC FOR ARABIC SPEAKERS I (previously ARABIC FOR NATIVE SPEAKERS I)
            <br/>060004 - ARABIC FOR ARABIC SPEAKERS II (previously ARABIC FOR NATIVE SPEAKERS II)
            <br/>060005 - ARABIC FOR ARABIC SPEAKERS III (previously ARABIC FOR NATIVE SPEAKERS III)
            <br/>060249 - SPANISH FOR SPANISH SPEAKERS I (previously SPANISH FOR NATIVE SPEAKERS I)
            <br/>060250 - SPANISH FOR SPANISH SPEAKERS II (previously SPANISH FOR NATIVE SPEAKERS II)
            <br/>060260 - SPANISH FOR SPANISH SPEAKERS III (previously SPANISH FOR NATIVE SPEAKERS III)
            </p>
            <br />

            <p><strong>{++changenum}. Course Codes with Description Changes</strong></p>
            <p className="changelist">
            158004 - CAMBRIDGE ADVANCED GEOGRAPHY (AS LEVEL)
            </p>
            <br />

            <p><strong>{++changenum}. Endorsement Codes Added</strong></p>
            <p className="changelist">
            058003 - CAMBRIDGE ADVANCED ENGLISH LITERATURE (AS LEVEL) added 0501 (ENGLISH), 0502 (ENGLISH LANGUAGE ARTS), and 0512 (SECONDARY ENGLISH)
            <br/>058004 - CAMBRIDGE ADVANCED GLOBAL PERSPECTIVES & RESEARCH (AS LEVEL) added 1501 (SOCIAL SCIENCE)
            <br/>088001 - CAMBRIDGE ADVANCED SPORT AND PHYSICAL EDUCATION (AS LEVEL) added 0802 (PHYSICAL EDUCATION) and 2304 (HEALTH & PHYS EDUC)
            <br/>128000 - CAMBRIDGE ADVANCED MUSIC (AS LEVEL) added 1201 (MUSIC) and 1203 (VOCAL MUSIC)
            <br/>138003 - CAMBRIDGE ADVANCED BIOLOGY (AS LEVEL) added 1301 (SCIENCE) and 1303 (BIOLOGY)
            <br/>138004 - CAMBRIDGE ADVANCED MARINE SCIENCE (AS LEVEL) added 1301 (SCIENCE) and 1303 (BIOLOGY)
            <br/>158004 - CAMBRIDGE ADVANCED GEOGRAPHY (AS LEVEL) added 1501 (SOCIAL SCIENCE)
            <br/>191615 - SPECIAL EDUCATION WORK EXPERIENCE - 6-12+ (PAC 1161) added 1923 (SPED INCLUSION/COLLAB SPEC SUP)
            <br/>191630 - SPECIAL EDUCATION WORK EXPERIENCE (PAC 1162) added 1923 (SPED INCLUSION/COLLAB SPEC SUP)
            <br/>192000 - SPECIAL ED FUNCTIONAL SKILLS AND ACTIVITIES (PAC 1162) added 1923 (SPED INCLUSION/COLLAB SPEC SUP)
            <br/>192015 - SPECIAL EDUCATION INDEPENDENT LIVING - K-12 (PAC 1161) added 1923 (SPED INCLUSION/COLLAB SPEC SUP)
            <br/>290101 - SUPPLEMENTAL READING added 1923 (SPED INCLUSION/COLLAB SPEC SUP)
            <br/>290102 - SUPPLEMENTAL MATH added 1923 (SPED INCLUSION/COLLAB SPEC SUP)
            </p>
            <br />

            <p><strong>{++changenum}. Endorsement Codes Removed</strong></p>
            <p className="changelist">
            191615 - SPECIAL EDUCATION WORK EXPERIENCE - 6-12+ (PAC 1161) removed 1906 (SPED INCLUSION/COLLAB SPC SUBJ)
            <br/>191630 - SPECIAL EDUCATION WORK EXPERIENCE (PAC 1162) removed 1906 (SPED INCLUSION/COLLAB SPC SUBJ)
            <br/>192000 - SPECIAL ED FUNCTIONAL SKILLS AND ACTIVITIES (PAC 1162) removed 1906 (SPED INCLUSION/COLLAB SPC SUBJ)
            <br/>192015 - SPECIAL EDUCATION INDEPENDENT LIVING - K-12 (PAC 1161) removed 1906 (SPED INCLUSION/COLLAB SPC SUBJ)
            <br/>290101 - SUPPLEMENTAL READING removed 1906 (SPED INCLUSION/COLLAB SPC SUBJ)
            <br/>290102 - SUPPLEMENTAL MATH removed 1906 (SPED INCLUSION/COLLAB SPC SUBJ)
            </p>
            <br />

            <p className="title is-4">
                <strong>Version 16.0.0</strong>
                <br />
                <strong>April 7, 2025</strong>
            </p>
            <br />
            <p><strong>{++changenum}. New Course Codes</strong></p>
            <p className="changelist">
            018073 - CASE ENVIRONMENTAL SCIENCE ISSUES
            <br/>018074 - CASE ANIMAL HEALTH AND VETERINARY SCIENCE
            <br/>020106 - CRAFTS AND FOLK ARTS
            <br/>058003 - CAMBRIDGE ADVANCED ENGLISH LITERATURE (AS LEVEL)
            <br/>058004 - CAMBRIDGE ADVANCED GLOBAL PERSPECTIVES AND RESEARCH (AS LEVEL)
            <br/>088001 - CAMBRIDGE ADVANCED SPORT AND PHYSICAL EDUCATION (AS LEVEL)
            <br/>128000 - CAMBRIDGE ADVANCED MUSIC (AS LEVEL)
            <br/>138003 - CAMBRIDGE ADVANCED BIOLOGY (AS LEVEL)
            <br/>138004 - CAMBRIDGE ADVANCED MARINE SCIENCE (AS LEVEL)
            <br/>158004 - CAMBRIDGE ADVANCED GEOGRAPHY (AS LEVEL)
            <br/>321001 - JOBS FOR AMERICA’S GRADUATES (JAG) MIDDLE SCHOOL (7TH-8TH)
            <br/>321002 - JOBS FOR AMERICA’S GRADUATES (JAG) 9TH GRADE
            <br/>321003 - JOBS FOR AMERICA’S GRADUATES (JAG) 10TH GRADE
            <br/>321004 - JOBS FOR AMERICA’S GRADUATES (JAG) 11TH GRADE
            <br/>321005 - JOBS FOR AMERICA’S GRADUATES (JAG) 12TH GRADE  
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes Removed</strong></p>
            <p className="changelist">
            018070 - CASE AGRICULTURAL BUSINESS FOUNDATION<br />
                <br />
            </p>
            <p><strong>{++changenum}. Course Codes with Name Changes</strong></p>
            <p className="changelist">
            018067 - CASE AGRICULTURAL BUSINESS FOUNDATION (previously CASE AGRICULTURAL BUSINESS)
            <br/>018068 - CASE AGXPLORE MIDDLE SCHOOL (previously CASE AGXPLORE)
            <br/>068000 - CAMBRIDGE ADVANCED FRENCH (AS LEVEL) (previously CAMBRIDGE AS FRENCH)
            <br/>278000 - CAMBRIDGE ADVANCED COMPUTER SCIENCE (AS LEVEL) (previously CAMBRIDGE AS COMPUTER SCIENCE)
    
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Name and Description Changes</strong></p>
            <p className="changelist">
            020100 – HIGH SCHOOL VISUAL ARTS I (previously VISUAL ARTS I)
            <br/>020200 – HIGH SCHOOL VISUAL ARTS II (previously VISUAL ARTS II)
            <br/>020300 - HIGH SCHOOL VISUAL ARTS III (previously VISUAL ARTS III)
            <br/>060108 - WORLD LANGUAGE LATIN III (previously LATIN III)
            <br/>060109 - WORLD LANGUAGE LATIN IV (previously LATIN IV)
            <br/>068001 - CAMBRIDGE ADVANCED SPANISH (previously CAMBRIDGE AS SPANISH - FIRST LANGUAGE)
            <br/>120100 – MIDDLE SCHOOL MUSIC - GENERAL (previously MUSIC – GENERAL)
            <br/>120400 - HIGH SCHOOL CHORUS (previously CHORUS)
            <br/>120502 - HIGH SCHOOL CONCERT BAND (previously CONCERT BAND)
            <br/>120506 - HIGH SCHOOL ORCHESTRA (previously ORCHESTRA)
            <br/>120550 - HIGH SCHOOL SMALL ENSEMBLE INSTRUMENTAL (previously SMALL ENSEMBLE INSTRUMENTAL)
            <br/>193000 - ADAPTED PHYSICAL EDUCATION (previously SPECIAL EDUCATION, ADAPTED PHYSICAL EDUCATION)
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Description Changes</strong></p>
            <p className="changelist">
            011004 - ANIMAL SCIENCE
            <br/>020702 - VISUAL ARTS - INDEPENDENT STUDY
            <br/>020703 - VISUAL ARTS – WORK-BASED LEARNING
            <br/>020800 – ART - MIDDLE SCHOOL/JUNIOR HIGH I
            <br/>020801 – ART - MIDDLE SCHOOL/JUNIOR HIGH II
            <br/>020802 – ART - SCHOOL GRADES/JUNIOR HIGH III
            <br/>058002 - CAMBRIDGE AS ENGLISH GENERAL PAPER
            <br/>080102 - FOUNDATIONS OF HEALTH EDUCATION
            <br/>080107 - FOUNDATIONS FOR PHYSICAL EDUCATION AND FITNESS
            <br/>080111 - INTRODUCTION TO STRENGTH & CONDITIONING
            <br/>080130 - GENERAL DANCE
            <br/>080139 - DANCE REPERTORY
            <br/>120401 - MIDDLE SCHOOL CHORUS
            <br/>120503 - MIDDLE SCHOOL CONCERT BAND
            <br/>120507 - MIDDLE SCHOOL ORCHESTRA
            <br/>120508 - BEGINNING – STRINGS
            <br/>120552 - MS SMALL ENSEMBLE – INSTRUMENTAL
            <br/>120802 – MUSIC - INDEPENDENT STUDY
            <br/>130214 - MICROBIOLOGY
            <br/>130301 - CHEMISTRY
            <br/>130303 - PHYSICS
            <br/>130304 - PRINCIPLES OF TECHNOLOGY I (SCIENCE)
            <br/>130312 - ASTRONOMY
            <br/>135023 - ADVANCED PLACEMENT PHYSICS C: ELECTRICITY AND MAGNETISM
            <br/>135025 - METEOROLOGY
            <br/>150016 - 8TH GRADE UNITED STATES HISTORY
            <br/>150700 - HIGH SCHOOL GEOGRAPHY
            <br/>150750 - ADVANCED PLACEMENT HUMAN GEOGRAPHY
            <br/>150810 - NEBRASKA HISTORY
            <br/>150830 - ADVANCED PLACEMENT US HISTORY
            <br/>151100 - POLITICAL SCIENCE
            <br/>151113 - ADVANCED PLACEMENT UNITED STATES GOVERNMENT AND POLITICS
            <br/>151115 - ADVANCED PLACEMENT COMPARITIVE GOVERNMENT AND POLITICS
            <br/>152000 - HOLOCAUST HISTORY
            <br/>158002 - CAMBRIDGE AS PSYCHOLOGY
            <br/>159930 - 159934 - SOCIAL SCIENCE, OTHER
            <br/>190215 - SPECIAL EDUCATION ART - K-12 (PAC 1161)
            <br/>190230 - SPECIAL EDUCATION ART (PAC 1162)
            <br/>190515 - SPECIAL EDUCATION LANGUAGE ARTS - K-12 (PAC1161)
            <br/>190530 - SPECIAL EDUCATION LANGUAGE ARTS (PAC 1162)
            <br/>191115 - SPECIAL EDUCATION MATHEMATICS - K-12 (PAC 1161)
            <br/>191130 - SPECIAL EDUCATION MATHEMATICS (PAC 1162)
            <br/>191215 - SPECIAL EDUCATION MUSIC - K-12 (PAC 1161)
            <br/>191230 - SPECIAL EDUCATION MUSIC (PAC 1162)
            <br/>191315 - SPECIAL EDUCATION SCIENCE - K-12 (PAC 1161)
            <br/>191330 - SPECIAL EDUCATION SCIENCE (PAC 1162)
            <br/>191515 - SPECIAL EDUCATION SOCIAL STUDIES - K-12 (PAC 1161)
            <br/>191530 - SPECIAL EDUCATION SOCIAL STUDIES (PAC 1162)
            <br/>191615 - SPECIAL EDUCATION WORK EXPERIENCE 9-12+ (PAC 1161)
            <br/>191630 - SPECIAL EDUCATION WORK EXPERIENCE (PAC 1162)
            <br/>192000 - SPECIAL ED FUNCTIONAL SKILLS AND ACTIVITIES (PAC 1162)
            <br/>192015 - SPECIAL EDUCATION INDEPENDENT LIVING - K-12 (PAC 1161)
            <br/>193000 - ADAPTED PHYSICAL EDUCATION
            <br/>194000 - EARLY CHILDHOOD SPECIAL EDUCATION IN-HOME SETTING
            <br/>220300 – THEATRE - STAGECRAFT
            <br/>220400 – THEATRE - DIRECTING
            <br/>220702 – THEATRE - INDEPENDENT STUDY
            <br/>220703 - THEATRE WORK-BASED LEARNING
            <br/>229930 - 229934 - THEATRE, OTHER
            <br/>370031 - PROSTART II
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been ADDED for the following course codes</strong></p>
            <p className="changelist">
            050053 - IB LANGUAGE A (ENGLISH) MIDDLE YEARS PROGRAM added 1817 MIDDLE LVL/ELA
            <br/>050054 - AP SEMINAR ENGLISH added 0512 SECONDARY ENGLISH
            <br/>077402 - EMERGENCY MEDICAL TECHNICIAN CERTIFICATION added 2912	LAW,PUBLIC SAFE,CORRECT,SECURE
            </p>
            <br />
            <p><strong>{++changenum}. Recommended Grade Level updates</strong></p>
            <p className="changelist">
            020202 - ANIMATION
            <br/>020500 - AP - 2D VISUAL ART AND DESIGN
            <br/>020501 - AP - 3D VISUAL ART AND DESIGN
            <br/>020502 - AP VISUAL ART DRAWING
            <br/>020503 - AP ART HISTORY
            <br/>020600 - PHOTOGRAPHY
            <br/>020800 – ART - MIDDLE SCHOOL/JUNIOR HIGH I
            <br/>020801 – ART - MIDDLE SCHOOL/JUNIOR HIGH II
            <br/>020802 - ART-SCHOOL GRADES/JUNIOR HIGH III
            <br/>060001 - WORLD LANGUAGE ARABIC I
            <br/>060002 - WORLD LANGUAGE ARABIC II
            <br/>060006 - WORLD LANGUAGE ARABIC III
            <br/>060007 - WORLD LANGUAGE ARABIC IV
            <br/>060105 - WORLD LANGUAGE LATIN I
            <br/>060106 - WORLD LANGUAGE LATIN II
            <br/>060107 - ADVANCED PLACEMENT LATIN
            <br/>060109 - WORLD LANGUAGE LATIN IV
            <br/>060111 - LATIN IB CLASSICAL LANGUAGE
            <br/>060221 - WORLD LANGUAGE FRENCH I
            <br/>060222 - WORLD LANGUAGE FRENCH II
            <br/>060223 - WORLD LANGUAGE FRENCH III
            <br/>060224 - WORLD LANGUAGE FRENCH IV
            <br/>060226 - ADVANCED PLACEMENT FRENCH LANGUAGE AND CULTURE
            <br/>060227 - IB LANGUAGE A - FRENCH
            <br/>060228 - IB LANGUAGE B - FRENCH
            <br/>060231 - WORLD LANGUAGE GERMAN I
            <br/>060232 - WORLD LANGUAGE GERMAN II
            <br/>060233 - WORLD LANGUAGE GERMAN III
            <br/>060234 - WORLD LANGUAGE GERMAN IV
            <br/>060235 - WORLD LANGUAGE GERMAN V
            <br/>060236 - ADVANCED PLACEMENT GERMAN LANGUAGE AND CULTURE
            <br/>060237 - IB LANGUAGE A - GERMAN
            <br/>060238 - IB LANGUAGE B - GERMAN
            <br/>060241 - WORLD LANGUAGE SPANISH I
            <br/>060242 - WORLD LANGUAGE SPANISH II
            <br/>060243 - WORLD LANGUAGE SPANISH III
            <br/>060244 - WORLD LANGUAGE SPANISH IV
            <br/>060245 - WORLD LANGUAGE SPANISH V
            <br/>060246 - ADVANCED PLACEMENT SPANISH LANGUAGE AND CULTURE
            <br/>060247 - IB LANGUAGE A - SPANISH
            <br/>060248 - IB LANGUAGE B - SPANISH
            <br/>060249 - SPANISH FOR NATIVE SPEAKERS I
            <br/>060250 - SPANISH FOR NATIVE SPEAKERS II
            <br/>060251 - WORLD LANGUAGE JAPANESE I
            <br/>060252 - WORLD LANGUAGE JAPANESE II
            <br/>060253 - ADVANCED PLACEMENT JAPANESE LANGUAGE AND CULTURE
            <br/>060254 - WORLD LANGUAGE JAPANESE III
            <br/>060255 - ADVANCED PLACEMENT SPANISH LITERATURE AND CULTURE
            <br/>060260 - SPANISH FOR NATIVE SPEAKERS III
            <br/>060261 - WORLD LANGUAGE RUSSIAN I
            <br/>060262 - WORLD LANGUAGE RUSSIAN II
            <br/>060271 - WORLD LANGUAGE CHINESE I
            <br/>060272 - WORLD LANGUAGE CHINESE II
            <br/>060273 - WORLD LANGUAGE CHINESE III
            <br/>060274 - WORLD LANGUAGE CHINESE IV
            <br/>060275 - WORLD LANGUAGE CHINESE V
            <br/>060276 - ADVANCED PLACEMENT CHINESE LANGUAGE AND CULTURE
            <br/>060277 - WORLD LANGUAGE JAPANESE IV
            <br/>062021 - MIDDLE SCHOOL EXPLORATORY FRENCH
            <br/>062041 - MIDDLE SCHOOL EXPLORATORY SPANISH
            <br/>064100 - AMERICAN SIGN LANGUAGE I
            <br/>064101 - AMERICAN SIGN LANGUAGE II
            <br/>064102 - AMERICAN SIGN LANGUAGE III
            <br/>064103 - AMERICAN SIGN LANGUAGE IV
            <br/>069930 - 069934 - WORLD LANGUAGE, OTHER
            <br/>080117 - HIP-HOP DANCE
            <br/>080131 - DANCE CHOREOGRAPHY
            <br/>120101 - ELEMENTARY GENERAL MUSIC (K-2)
            <br/>120501 - GENERAL BAND - BEGINNING
            <br/>120600 - INDIVIDUAL INSTRUCTION/VOCAL
            <br/>120650 - INDIVIDUAL INSTRUCTION/INSTRUMENTAL
            <br/>120808 - RECORDING AND PRODUCTION
            <br/>191615 - SPECIAL EDUCATION WORK EXPERIENCE 9-12+ (PAC 1161)
            <br/>193000 - SPECIAL EDUCATION, ADAPTED PHYSICAL EDUCATION
            <br/>220100 - INTRODUCTION TO THEATRE
            <br/>370031 - PROSTART II
            </p>
            <br />
            <p><strong>{++changenum}. Career Cluster Added</strong></p>
            <p className="changelist">
            278000 - CAMBRIDGE ADVANCED COMPUTER SCIENCE (AS LEVEL) (added INFORMATION TECHNOLOGY)
            </p>
            <br />
            <br />
            <br />
            <p className="title is-4">
                <strong>Version 15.0.0</strong>
                <br />
                <strong>April 1, 2024</strong>
            </p>
            <br />
            <p><strong>{++changenum}. New Course Codes</strong></p>
            <p className="changelist">
                 018069 - CASE AG EQUIPMENT MAINTENANCE AND TECHNOLOGY 
            <br/>018070 - CASE AGRICULTURAL BUSINESS FOUNDATION 
            <br/>018071 - CASE AGRICULTURAL RESEARCH AND DEVELOPMENT 
            <br/>018072 - CASE SMALL GAS ENGINES 
            <br/>058001 - CAMBRIDGE AS ENGLISH LANGUAGE 
            <br/>058002 - CAMBRIDGE AS ENGLISH GENERAL PAPER 
            <br/>060006 - WORLD LANGUAGE ARABIC III 
            <br/>060007 - WORLD LANGUAGE ARABIC IV 
            <br/>060277 - WORLD LANGUAGE JAPANESE IV 
            <br/>068000 - CAMBRIDGE AS FRENCH 
            <br/>068001 - CAMBRIDGE AS SPANISH - FIRST LANGUAGE 
            <br/>088000 - CAMBRIDGE AS PHYSICAL EDUCATION 
            <br/>100166 - PLTW ENGINEERING ESSENTIALS 
            <br/>100167 - PLTW ENVIRONMENTAL SUSTAINABILITY 
            <br/>138001 - CAMBRIDGE AS CHEMISTRY 
            <br/>138002 - CAMBRIDGE AS ENVIRONMENTAL MANAGEMENT 
            <br/>158001 - CAMBRIDGE AS ECONOMICS 
            <br/>158002 - CAMBRIDGE AS PSYCHOLOGY 
            <br/>158003 - CAMBRIDGE AS SOCIOLOGY 
            <br/>270415 - INTRODUCTION TO COMPUTER SCIENCE AND TECHNOLOGY 
            <br/>278000 - CAMBRIDGE AS COMPUTER SCIENCE 
            <br/>300103 - AS THINKING SKILLS     
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes Removed</strong></p>
            <p className="changelist">
                090125 - DIETETICS<br />
                <br />
            </p>
            <p><strong>{++changenum}. Course Codes with Name Changes</strong></p>
            <p className="changelist">
                 031805 - BUSINESS STRATEGIES (previously BUSNESS STRATEGIES)
            <br/>090134 - BEST PRACTICES IN EARLY CHILDHOOD EDUCATION WITH WORK-BASED LEARNING (previously BEST PRACTICES IN EARLY CHILDHOOD ED W/WORK-BASED LEARNING)
            <br/>350002 - BEST PRACTICES IN EDUCATION AND TRAINING WITH WORK-BASED LEARNING (previously BEST PRACTICES IN EDUCATION AND TRAINING WITH WBL)       
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Name and Description Changes</strong></p>
            <p className="changelist">
                 110623 - IB MATHEMATICS: APPLICATIONS AND INTERPRETATION SL (previously IB MATHEMATICAL STUDIES-STANDARD LEVEL)
            <br/>110624 - IB MATHEMATICS: ANALYSIS AND APPROACHES SL (previously IB MATHEMATICS STANDARD LEVEL)
            <br/>110625 - IB MATHEMATICS: APPLICATIONS AND INTERPRETATION HL (previously IB FURTHER MATHEMATICS-HIGHER LEVEL)
            <br/>110627 - IB MATHEMATICS: ANALYSIS AND APPROACHES HL (previously IB MATHEMATICS-HIGHER LEVEL)
            <br/>194000 - EARLY CHILDHOOD SPECIAL EDUCATION IN-HOME SETTING (previously SPECIAL EDUCATION IN-HOME SETTING)
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Description Changes</strong></p>
            <p className="changelist">
                 011004 - ANIMAL SCIENCE
            <br/>011005 - LARGE ANIMAL MANAGEMENT
            <br/>011007 - PLANT SCIENCE
            <br/>011008 - CROP MANAGEMENT/AGRONOMY
            <br/>011009 - AGRIBUSINESS
            <br/>050001 - LANGUAGE ARTS/SKILLS
            <br/>050008 - LINGUISTICS
            <br/>050011 - ENGLISH
            <br/>050021 - ENGLISH I
            <br/>050022 - ENGLISH II
            <br/>050023 - ENGLISH III
            <br/>050024 - ENGLISH IV
            <br/>050054 - AP SEMINAR ENGLISH
            <br/>050100 - CREATIVE WRITING/COMPOSITION
            <br/>050102 - READING
            <br/>050800 - MIDDLE SCHOOL READING I
            <br/>050801 - MIDDLE SCHOOL READING II
            <br/>065001 - WORLD LANGUAGE COMPETENCY-BASED CREDIT
            <br/>077400 - NURSING ASSISTANT/CNA
            <br/>077402 - EMERGENCY MEDICAL TECHNICIAN CERTIFICATION
            <br/>077601 - EXERCISE SCIENCE
            <br/>077701 - PERFORMANCE NUTRITION
            <br/>090005 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 6
            <br/>090006 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 7
            <br/>090007 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 8
            <br/>120501 - GENERAL BAND-BEGINNING
            <br/>130313 - EARTH AND SPACE SCIENCE
            <br/>135022 - AP PHYSICS 2: ALGEBRA-BASED
            <br/>190215 - SPECIAL EDUCATION ART K-12 (PAC 1161)
            <br/>190230 - SPECIAL EDUCATION ART (PAC 1162)
            <br/>190515 - SPECIAL EDUCATION LANGUAGE ARTS K-12 (PAC 1161)
            <br/>190530 - SPECIAL EDUCATION LANGUAGE ARTS (PAC 1162)
            <br/>191115 - SPECIAL EDUCATION MATHEMATICS K-12 (PAC 1161)
            <br/>191130 - SPECIAL EDUCATION MATHEMATICS (PAC 1162)
            <br/>191215 - SPECIAL EDUCATION MUSIC K-12 (PAC 1161)
            <br/>191230 - SPECIAL EDUCATION MUSIC (PAC 1162)
            <br/>191315 - SPECIAL EDUCATION SCIENCE K-12 (PAC 1161)
            <br/>191330 - SPECIAL EDUCATION SCIENCE (PAC 1162)
            <br/>191515 - SPECIAL EDUCATION SOCIAL STUDIES K-12 (PAC 1161)
            <br/>191530 - SPECIAL EDUCATION SOCIAL STUDIES (PAC 1162)
            <br/>191615 - SPECIAL EDUCATION WORK EXPERIENCE 9-12+ (PAC 1161)
            <br/>191630 - SPECIAL EDUCATION WORK EXPERIENCE (PAC 1162)
            <br/>192000 - SPECIAL EDUCATION FUNCTIONAL SKILLS AND ACTIVITIES (PAC 1162)
            <br/>192015 - SPECIAL EDUCATION INDEPENDENT LIVING K-12 (PAC 1161)
            <br/>370030 - PROSTART I
            <br/>370031 - PROSTART II
            <br/>379930-379934 - HOSPITALITY AND TOURISM, OTHER
            <br/>390010 - FOUNDATIONS OF LAW, PUBLIC SAFETY, CORRECTIONS & SECURITY
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been ADDED for the following course codes</strong></p>
            <p className="changelist">
                 012005 - AGRICULTURAL ENTREPRENEURSHIP added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>016004 - WELDING added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>016006 - PRECISION AGRICULTURE added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>017000 - AG, FOOD, AND NATURAL RESOURCES LEADERSHIP, CAREER READINESS AND WBL EXPERIENCE added 1605 (WORK-BASED LEARNING) 
            <br/>018060 - CASE INTRODUCTION TO AGRICULTURE, FOOD AND NATURAL RESOURCES added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>018061 - CASE PLANT SCIENCE - added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>018062 - CASE ANIMAL SCIENCE - added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>018063 - CASE ANIMAL AND PLANT BIOTECHNOLOGY - added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>018064 - NATURAL RESOURCES AND ECOLOGY - added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>018065 - CASE FOOD SCIENCE AND SAFETY - added 2901 (AG, FOOD & NATURAL RESOURCES) 
            <br/>018068 - CASE AGXPLORE - added 1810 (MIDDLE LVL/AG EDUCATION) 
            <br/>030501 - ACCOUNTING 1 added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906(FINANCE) and 2914 (MARKETING) 
            <br/>030502 - ACCOUNTING 2 added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE) and 2914 (MARKETING) 
            <br/>030503 - ACCOUNTING 3 added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE) and 2914 (MARKETING) 
            <br/>030504 - ACCOUNTING 4 added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE) and 2914 (MARKETING) 
            <br/>032605 - COLLEGE ENTREPRENEURSHIP BUSINESS PLAN added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE) and 2914 (MARKETING) 
            <br/>038301 - INTRODUCTION TO HOSPITALITY AND EVENT PLANNING added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE),2909 (HOSPITALITY & TOURISM) and 2914 (MARKETING) 
            <br/>038302 - TRAVEL AND TOURISM added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE),2909 (HOSPITALITY & TOURISM) and 2914 (MARKETING) 
            <br/>038303 - EVENT MANAGEMENT WITH WORK-BASED LEARNING EXPERIENCE added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE),2909 (HOSPITALITY & TOURISM) and 2914 (MARKETING) 038302 - TRAVEL and 2914 (MARKETING) 
            <br/>038502 - COLLEGE MACROECONOMICS a added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE) and 2914 (MARKETING) 
            <br/>038503 - COLLEGE MICROECONOMICS added 2904 (BUSINESS MANAGEMENT & ADMIN), 2906 (FINANCE) and 2914 (MARKETING) 
            <br/>059930 - ENGLISH LANGUAGE ARTS (OTHER) added 0512 (SECONDARY ENGLISH) 077201 - PLTW MEDICAL DETECTIVES added 2908 (HEALTH SCIENCE) 
            <br/>077402 - EMERGENCY MEDICAL TECHNICIAN CERTIFICATION added 2908 (HEALTH SCIENCE) 077444 - PHARMACY TECHNICIAN added 2908 (HEALTH SCIENCE) 
            <br/>077446 - PHLEBOTOMY TECHNICIAN added 2908 (HEALTH SCIENCE) 077601 - EXERCISE SCIENCE added 2908 (HEALTH SCIENCE) 
            <br/>077701 - PEFORMANCE NUTRITION added 2908 (HEALTH SCIENCE) 077801 - BEHAVIORAL HEALTH I added 2908 (HEALTH SCIENCE) 
            <br/>077802 - BEHAVIORAL HEALTH II added 2908 (HEALTH SCIENCE) 077803 - PLTW PRINCIPALS OF BIOMEDICAL SCIENCE I added 2908 (HEALTH SCIENCE) 
            <br/>077804 - PLTW PRINCIPALS OF BIOMEDICAL SCIENCE II added 2908 (HEALTH SCIENCE) 
            <br/>077805 - PLTW HUMAN BODY SYSTEMS I added 2908 (HEALTH SCIENCE) 
            <br/>077806 - PLTW HUMAN BODY SYSTEMS II added 2908 (HEALTH SCIENCE) 
            <br/>077807 - PLTW MEDICAL INTERVENTIONS I added 2908 (HEALTH SCIENCE) 
            <br/>077808 - PLTW MEDICAL INTERVENTIONS II added 2908 (HEALTH SCIENCE) 
            <br/>077809 - PLTW BIOMEDICAL INNOVATION I added 2908 (HEALTH SCIENCE) 
            <br/>077810 - PLTW BIOMEDICAL INNOVATION II added 2908 (HEALTH SCIENCE) 
            <br/>077812 - HEALTH INFORMATION MANAGEMENT AND ETHICS added 2908 (HEALTH SCIENCE) 
            <br/>077900 - ALLIED HEALTH AND MEDICINE added 2908 (HEALTH SCIENCE)
            <br/>090101 - INTRODUCTION TO FAMILY AND CONSUMER SCIENCES added 2910 (HUMAN SERVICES) 
            <br/>090103 - APPAREL PRODUCTION AND CONSTRUCTION added 2910 (HUMAN SERVICES) 
            <br/>090104 - LIFE AND CAREER READINESS added 2910 (HUMAN SERVICES) 
            <br/>090107 - FUNDAMENTALS OF NUTRITION AND CULINARY ESSENTIALS added 2910 (HUMAN SERVICES) 
            <br/>090109 - HOME DESIGN AND INTERIORS added 2910 (HUMAN SERVICES) 
            <br/>090113 - FOOD SCIENCE added 2910 (HUMAN SERVICES) 
            <br/>090116 - INTERPERSONAL RELATIONSHIPS added 2910 (HUMAN SERVICES) 
            <br/>090117 - PARENTS AND FAMILIES added 2910 (HUMAN SERVICES) 
            <br/>090119 - CHILD DEVELOPMENT added 2910 (HUMAN SERVICES) 
            <br/>090122 - EARLY CHILDHOOD EDUCATION PRACTICUM WITH WORK-BASED LEARNING added 2910 (HUMAN SERVICES) and 2905 (EDUCATION & TRAINING) 
            <br/>090123 - LIFESPAN DEVELOPMENT added 2910 (HUMAN SERVICES) 
            <br/>090124 - NUTRITION added 2910 (HUMAN SERVICES) 
            <br/>090126 - INTRODUCTION TO DESIGN added 2910 (HUMAN SERVICES) 
            <br/>090127 - FAMILIES IN CRISIS added 2910 (HUMAN SERVICES) 
            <br/>090128 - CAREERS IN MENTAL HEALTH added 2910 (HUMAN SERVICES) 
            <br/>090132 - FAMILY AND COMMUNITY ADVOCACY added 2910 (HUMAN SERVICES) 
            <br/>090134 - BEST PRACTICES IN EARLY CHILDHOOD EDUCATION WITH WORK-BASED LEARNING added 2905 (EDUCATION & TRAINING) and 2910 (HUMAN SERVICES)
            <br/>090206 - FASHION DESIGN added 2910 (HUMAN SERVICES) 
            <br/>090208 - LEADERSHIP AND ETHICS IN HUMAN SERVICES added 2910 (HUMAN SERVICES) 
            <br/>099930-099934 - FCS/HUMAN SERVICES, OTHER added 2910 (HUMAN SERVICES) 
            <br/>190215 - SPECIAL EDUCATION LANGUAGE ARTS (PAC 1162) added 1802 (EARLY CHILDHOOD EDUCATION), 1804 (EARLY CHILDHOOD INCLUSIVE), 1830 (EARLY CHILDHOOD EDUCATION), 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>190230 - SPECIAL EDUCATION ART (PAC 1162) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>190515 - SPECIAL EDUCATION LANGUAGE ARTS K-12 (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>190530 - SPECIAL EDUCATION LANGUAGE ARTS (PAC 1162) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191115 - SPECIAL EDUCATION MATHEMATICS K-12 (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191130 - SPECIAL EDUCATION MATHEMATICS (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191215 - SPECIAL EDUCATION MUSIC K-12 (PAC 1161) added 1802 (SPED BEHAVIOR INT SUPP), 1804 (EARLY CHILDHOOD INCLUSIVE), 1830 (EARLY CHILDHOOD EDUCATION), 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191230 - SPECIAL EDUCATION MUSIC (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191315 - SPECIAL EDUCATION SCIENCE K-12 (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191330 - SPECIAL EDUCATION SCIENCE (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191515 - SPECIAL EDUCATION SOCIAL STUDIES K-12 (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191530 - SPECIAL EDUCATION SOCIAL STUDIES (PAC 1161) added 1913 (SPECIAL EDUCATION GENERALIST) and 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191615 - SPECIAL EDUCATION WORK EXPERIENCE 9-12+ (PAC 1161) added 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>191630 - SPECIAL EDUCATION WORK EXPERIENCE 9-12+ (PAC 1162) added 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>192000 - SPECIAL EDUCATION FUNCTIONAL SKILLS AND ACTIVITIES (PAC1162) added 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>192015 - SPECIAL EDUCATION INDEPENDENT LIVING K-12 (PAC 1161) added 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>193000 - SPECIAL EDUCATION ADAPTED PHYSICAL EDUCATION added 1921 (SPED BEHAVIOR INT SUPP) 
            <br/>270608 - INTRODUCTION TO MEDIA added 2903 (COMMUNICATIONS ARTS) 
            <br/>270702 - ADVANCED PLACEMENT COMPUTER SCIENCES PRINCIPLES added 2903 (COMMUNICATIONS ARTS) and 2911 (INFORMATION TECHNOLOGY-CE) 
            <br/>270708 - PROJECT LEAD THE WAY - COMPUTER SCIENCES PRINCIPLES added 2903 (COMMUNICATIONS ARTS) and 2911 (INFORMATION TECHNOLOGY-CE) 
            <br/>270709 - PROJECT LEAD THE WAY - COMPUTER SCIENCE A added 2903 (COMMUNICATIONS ARTS) and 2911 (INFORMATION TECHNOLOGY-CE) 
            <br/>270710 - PROJECT LEAD THE WAY - COMPUTER SCIENCE ESSENTIALS added 2903 (COMMUNICATIONS ARTS) and 2911 (INFORMATION TECHNOLOGY-CE) 
            <br/>270711 - PROJECT LEAD THE WAY - CYBERSECURITY added 2903 (COMMUNICATIONS ARTS) and 2911 (INFORMATION TECHNOLOGY-CE)
            <br/>370010 - HOSPITALITY AND TOURISM added 2909 (HOSPITALITY & TOURISM) 
            <br/>370021 - CULINARY SKILLS 1 added 2909 (HOSPITALITY & TOURISM)
            <br/>370022 - CULINARY SKILLS 2 added 2909 (HOSPITALITY & TOURISM) 
            <br/>370023 - BAKING AND PASTRY added 2909 (HOSPITALITY & TOURISM) 
            <br/>370030 - PROSTART 1 added 2909 (HOSPITALITY & TOURISM) 
            <br/>370031 - PROSTART 2 added 2909 (HOSPITALITY & TOURISM) 
            <br/>379930-379934 - HOSPITALITY AND TOURISM, OTHER added 2909 (HOSPITALITY & TOURISM)
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been Removed for the following course codes</strong></p>
            <p className="changelist">
                 038303 - EVENT MANAGEMENT WITH WORK-BASED LEARNING EXPERIENCE removed 1605 (WORK-BASED LEARNING) 
            <br/>090122 - EARLY CHILDHOOD EDUCATION PRACTICUM WITH WORK-BASED LEARNING removed 1605 (WORK-BASED LEARNING)
            <br/>090134 - BEST PRACTICES IN EARLY CHILDHOOD EDUCATION WITH WORK-BASED LEARNING removed 1605 (WORK-BASED LEARNING)
            <br/>350002 - BEST PRACTICES IN EDUCATION AND TRAINING WITH WBL removed 1605 (WORK-BASED LEARNING) 
            <br/>350003 - EDUCATION AND TRAINING PRACTICUM WITH WORK-BASED LEARNING removed 1605 (WORK-BASED LEARNING)
            
            </p>
            <br />
            <br />
            <br />
            
            <p className="title is-4">
                <strong>Version 14.1.0</strong>
                <br />
                <strong>June 16, 2023</strong>
            </p>
            <p><strong>{++changenum}. Endorsement codes have been ADDED for the following course codes</strong></p>
            <p className="changelist">
            270505 - CISCO I: INTRODUCTION TO NETWORKS added 2911 Information Technology
            <br/>270506 - CISCO II: ROUTING AND SWITCHING ESSENTIALS added 2911 Information Technology
            <br/>270507 - CISCO III: SCALING NETWORKS added 2911 Information Technology
            <br/>270602 - Digital Media added 2903 Communication Arts
            <br/>270604 - Foundations of Web Design added 2903 Communication Arts
            <br/>270609 - Video Production added 2903 Communication Arts
            <br/>270610 - Media Production added 2903 Communication Arts
            <br/>270611 - Digital Design added 2903 Communication Arts
            <br/>270613 - Advanced Digital Design added 2903 Communication Arts
            <br/>270701 - Computer Science A added 2911 Information Technology
            <br/>270703 - Computer Science Principles added 2911 Information Technology
            <br/>270704 - Foundations of Computing added 2911 Information Technology
            <br/>270705 - Software Development added 2911 Information Technology
            <br/>270706 - Web Design & Development added 2911 Information Technology
            <br/>270707 - Cybersecurity added 2911 Information Technology

            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been REMOVED for the following course codes</strong></p>
            <p className="changelist">
            <br/>050052 - IB LANGUAGE A - (ENGLISH)) removed Endorsement 0508 (READING SPECIALIST)
            <br/>050053 - IB LANGUAGE A (ENGLISH) MIDDLE YEARS PROGRAM) removed Endorsement 0508 (READING SPECIALIST) and 1817 (MIDDLE LVL/ELA)
            <br/>
            </p>
            <br />
            <br />
            <br />
            <p className="title is-4">
                <strong>Version 14.0.0</strong>
                <br />
                <strong>April 10, 2023</strong>
            </p>
            <p><strong>{++changenum}. Subject Update</strong></p>
            <p className="changelist">
            FINE ARTS (ART) (02) updated to FINE ARTS (VISUAL ART) (02)<br />
            </p>
            <br />
            <p><strong>{++changenum}. New Course Codes</strong></p>
            <p className="changelist">
                011017 - AGRICULTURAL COMMUNICATIONS <br />
                011018 - AGRICULTURAL TECHNOLOGY <br />
                011019 - DIVERSIFIED AGRICULTURE <br />
                011020 - INTEGRATED AGRICULTURAL SCIENCE <br />
                012006 - LANDSCAPE DESIGN <br />
                018067 - CASE AGRIBUSINESS <br />
                018068 - CASE AGXPLORE <br />
                020101 - FUNDAMENTALS OF DESIGN <br />
                020102 - VISUAL COMMUNICATIONS DESIGN <br />
                020103 - MULTIMEDIA ART <br />
                020104 - PRINTMAKING/GRAPHICS <br />
                020105 - JEWELRY <br />
                020201 - CINEMATOGRAPHY/VIDEO PRODUCTION <br />
                020202 - ANIMATION<br />
                020203 - FILM APPRECIATION AND ANALYSIS<br />
                020601 - DIGITAL IMAGING<br />
                020602 - MEDIA ARTS COMPREHENSIVE<br />
                020603 - INTERACTIVE DESIGN<br />
                020604 - DIGITAL SOUND DESIGN<br />
                020605 - VIRTUAL DESIGN<br />
                020704 - ART PORTFOLIO<br />
                020705 - VISUALS ART APPRECIATION AND HISTORY<br />
                020706 - VISUAL ARTS - DRAWING/PAINTING<br />
                020707 - VISUAL ARTS - SCULPTURE<br />
                020708 - VISUAL ARTS - CERAMICS/POTTERY<br />
                020709 - VISUAL ARTS - GRADES K-2<br />
                020710 - VISUAL ARTS - GRADES 3-5<br />
                020711 - INTERNATIONAL BACCALAUREATE FILM<br />
                020712 - MS INTERNATIONAL BACCALAUREATE ARTS<br />
                038301 - INTRODUCTION TO HOSPITALITY AND EVENT PLANNING<br />
                038302 - TRAVEL AND TOURISM<br />
                038303 - EVENT MANAGEMENT WITH WORK-BASED LEARNING EXPERIENCE<br />
                050054 - AP SEMINAR ENGLISH<br />
                060003 - ARABIC FOR NATIVE SPEAKERS I<br />
                060004 - ARABIC FOR NATIVE SPEAKERS II<br />
                060005 - ARABIC FOR NATIVE SPEAKERS III<br />
                065001 - WORLD LANGUAGE COMPETENCY-BASED CREDIT<br />
                080129 - UNIFIED PHYSICAL EDUCATION<br />
                080130 - GENERAL DANCE<br />
                080131 - DANCE CHOREOGRAPHY<br />
                080132 - DANCE IMPROVISATION<br />
                080133 - WORLD/CULTURAL DANCE<br />
                080134 - BALLET<br />
                080135 - JAZZ DANCE<br />
                080136 - MODERN DANCE<br />
                080137 - TAP DANCE<br />
                080138 - DANCE GENERAL ELEMENTARY<br />
                080139 - DANCE REPERTORY<br />
                090132 - FAMILY AND COMMUNITY ADVOCACY<br />
                090133 - LIFESPAN NUTRITION AND WELLNESS<br />
                090134 - BEST PRACTICES IN EARLY CHILDHOOD ED W/WORK-BASED LEARNING<br />
                099936 - MIDDLE SCHOOL FCS/HUMAN SERVICES, OTHER<br />
                099937 - MIDDLE SCHOOL FCS/HUMAN SERVICES, OTHER<br />
                101651 - POWER EQUIPMENT<br />
                110601 - AP PRE-CALCULUS<br />
                120101 - ELEMENTARY GENERAL MUSIC (K-2)<br />
                120102 - ELEMENTARY GENERAL MUSIC (3-5)<br />
                120103 - MUSIC HISTORY/APPRECIATION<br />
                120401 - MIDDLE SCHOOL CHORUS<br />
                120451 - MIDDLE SCHOOL VOCAL ENSEMBLE<br />
                120452 - CONTEMPORARY VOCAL ENSEMBLE<br />
                120501 - GENERAL BAND-BEGINNING<br />
                120502 - CONCERT BAND<br />
                120503 - MIDDLE SCHOOL CONCERT BAND<br />
                120504 - MARCHING BAND<br />
                120505 - CONCERT AND MARCHING BAND<br />
                120506 - ORCHESTRA<br />
                120507 - MIDDLE SCHOOL ORCHESTRA<br />
                120508 - BEGINNING - STRINGS<br />
                120551 - CONTEMPORARY INSTRUMENTAL ENSEMBLE<br />
                120552 - MS SMALL ENSEMBLE - INSTRUMENTAL<br />
                120651 - PIANO<br />
                120652 - GUITAR<br />
                120808 - RECORDING AND PRODUCTION<br />
                220101 - THEATER COMPREHENSIVE<br />
                220102 - ELEMENTARY THEATRE/DRAMA<br />
                220103 - HISTORY AND LITERATURE OF THE THEATER<br />
                220201 - MUSICAL THEATER<br />
                220202 - DANCE FOR MUSICAL THEATRE<br />
                220501 - TECHNICAL THEATRE<br />
                220502 - PLAYWRITING AND SCREENWRITING<br />
                229931 - THEATRE, OTHER<br />
                229932 - THEATRE, OTHER<br />
                229933 - THEATRE, OTHER<br />
                229934 - THEATRE, OTHER<br />
                270413 - INTRODUCTION TO DATA SCIENCE<br />
                270414 - DATA LITERACY AND VISUALIZATION<br />
                350003 - EDUCATION & TRAINING PRACTICUM WITH WORK-BASED LEARNING<br />
                370023 - BAKING AND PASTRY<br />
                390021 - EMERGENCY & FIRE MANAGEMENT<br />
                390030 - INTRODUCTION TO CORRECTIONS<br />     
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes Removed</strong></p>
            <p className="changelist">
                020400 - ART IV<br />
                077702 - HUMAN LIFE CYCLE NUTRITION<br />
                090121 - EARLY CHILDHOOD EDUCATION AND SERVICES<br />
                090207 - THE BUSINESS OF TEXTILES<br />
                090209 - CONSUMER ECONOMICS<br />
                120500 - INSTRUMENTAL MUSIC<br />
                350010 - FIELD EXPERIENCE IN EDUCATION AND TRAINING<br />
            </p>
            <br />            
            <p><strong>{++changenum}. Course Codes with Name Changes</strong></p>
            <p className="changelist">
            080123 - LIFEGUARD TRAINING & WATER SAFETY INSTRUCTION AIDE (previously LIFEGUARD TRAINING & WATER SAFETY INSTRICTION AIDE)<br />
            099931 - FCS/HUMAN SERVICES, OTHER (previously HUMAN SERVICES/FCS, OTHER)<br />
            120804 - MUSIC THEORY (previously MUSIC THEORY FUNDAMENTALS)<br />
            120806 - CULTURALLY INFLUENCED ENSEMBLE (previously MUSIC CULTURAL ENSEMBLES)<br />        
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Name and Description Changes</strong></p>
            <p className="changelist">
            011011 - AGRICULTURAL SALES (previously AGRICULTURAL SALES & COMMUNICATIONS)<br />
            012001 - NURSERY MANAGEMENT (previously NURSERY AND LANDSCAPE)<br />
            012005 - AGRICULTURAL ENTREPRENEURSHIP (previously AGRIBUSINESS MANAGEMENT AND ENTREPRENEURSHIP)<br />
            016000 - POWER, STRUCTURAL AND TECHNOLOGY SYSTEMS FUNDAMENTALS (previously POWER, STRUCTURAL AND TECHNICAL FOUNDATIONS)<br />
            016003 - ADVANCED POWER, STRUCTURAL AND TECHNOLOGY SYSTEMS (previously POWER, STRUCTURAL AND TECHNOLOGY SYSTEMS)<br />
            016006 - PRECISION AGRICULTURE (previously PRECISION AGRICULTURE AND ENGINEERING)<br />
            017000 - AG, FOOD, AND NAT RES LEAD, CAREER READINESS AND WBL EXPER (previously AGRICULTURAL LEADERSHIP AND CAREER READINESS)<br />
            019930-019934 - AGRICULTURE, FOOD AND NATURAL RESOURCES, OTHER (previously MIDDLE SCHOOL AGRICULTURE, FOOD AND NATURAL RESOURCES, OTHER)<br />
            020100 - VISUAL ARTS I (previously ART I)<br />
            020200 - VISUAL ARTS II (previously ART II)<br />
            020300 - VISUAL ARTS III (previously ART III)<br />
            020500 - AP - 2D VISUAL ART AND DESIGN (previously ADVANCED PLACEMENT STUDIO ART 2D)<br />
            020501 - AP - 3D VISUAL ART AND DESIGN (previously ADVANCED PLACEMENT STUDIO ART 3D)<br />
            020502 - AP VISUAL ART DRAWING (previously ADVANCED PLACEMENT STUDIO ART DRAW)<br />
            020503 - AP ART HISTORY (previously ADVANCED PLACEMENT ART HISTORY)<br />
            029930-029934 - VISUAL ARTS, OTHER (previously ART, OTHER)<br />
            077304 - EXPLORING LABORATORY MEDICINE WITH WORK BASED LEARNING (previously EXPLORING LABORATORY MEDICINE)<br />
            077401 - MEDICATION AIDE CERTIFICATION (previously MEDICATION AIDE)<br />
            080118 - SOCIAL DANCE (previously BALLROOM DANCE)<br />
            090103 - APPAREL PRODUCTION AND CONSTRUCTION (previously TEXTILE CONSTRUCTION)<br />
            090107 - FUNDAMENTALS OF NUTRITION AND CULINARY ESSENTIALS (previously FUNDAMENTALS OF FOOD AND NUTRITION)<br />
            090109 - HOUSING DESIGN AND INTERIORS (previously HOME DESIGN AND INTERIORS)<br />
            090122 - EARLY CHILDHOOD EDUCATION PRACTICUM WITH WORK-BASED LEARNING (previously EARLY CHILDHOOD PRACTICUM)<br />
            090123 - LIFESPAN DEVELOPMENT (previously HUMAN GROWTH AND DEVELOPMENT)<br />
            090126 - INTRODUCTION TO DESIGN (previously INTRODUCTION TO DESIGN PRINCIPLES)<br />
            099930- 099934 - FCS/HUMAN SERVICES, OTHER (previously HUMAN SERVICES/FCS, OTHER)<br />
            099935 - MIDDLE SCHOOL FCS/HUMAN SERVICES, OTHER (previously MIDDLE SCHOOL HUMAN SERVICES/FCS, OTHER)<br />
            100405 - RESIDENTIAL ELECTRICAL WIRING (previously ELECTRICITY)<br />
            120100 - MUSIC – GENERAL (previously MUSIC)<br />
            120400 - CHORUS (previously VOCAL MUSIC)<br />
            120450 - VOCAL ENSEMBLE (previously SMALL PERFORMING GROUPS/VOCAL)<br />
            120550 - SMALL ENSEMBLE INSTRUMENTAL (previously SMALL PERFORMING GROUPS/INSTRUMENTAL)<br />
            350001 - TEACHING AS A PROFESSION (previously INTRODUCTION TO EDUCATION AND TRAINING)<br />
            350002 - BEST PRACTICES IN EDUCATION AND TRAINING WITH WBL (previously BEST PRACTICES IN EDUCATION AND TRAINING)<br />
            399930- 399934 - LAW, PUBLIC SAFETY, CORRECTIONS, AND SECURITY, OTHER (previously LAW, PUBLIC SAFETY AND SECURITY, OTHER)<br />
            </p>
            <br />
            {/* <p><strong>{++changenum}. Course Codes with Name Change and Endorsements Added</strong></p>
            <p className="changelist">
                320300 - MIDDLE SCHOOL ENGAGE! CAREER EXPLORATION AND READINESS (previously ENGAGE! CAREER EXPLORATION AND READINESS) added 0700 (HEALTH SCIENCES EDUCATION) and 2908 (HEALTH SCIENCE)<br /> 
            </p>
            <br /> */}
            <p><strong>{++changenum}. Course Codes with Description Changes</strong></p>
            <p className="changelist">
            011000 - INTRODUCTION TO AGRICULTURE, FOOD AND NATURAL RESOURCES
            <br/>011005 - LARGE ANIMAL MANAGEMENT
            <br/>011006 - SMALL ANIMAL MANAGEMENT
            <br/>011007 - PLANT SCIENCE
            <br/>011008 - CROP MANAGEMENT/AGRONOMY
            <br/>011009 - AGRIBUSINESS
            <br/>011010 - AGRICULTURAL ECONOMICS
            <br/>011015 - VETERINARY SCIENCE
            <br/>012002 - FLORICULTURE
            <br/>012004 - AGRICULTURE BIOTECHNOLOGY
            <br/>013000 - ENVIRONMENTAL AND NATURAL RESOURCES
            <br/>013001 - WILDLIFE MANAGEMENT
            <br/>013002 - ENVIRONMENTAL AND NATURAL RESOURCES MANAGEMENT
            <br/>014000 - FOOD SCIENCE AND SAFETY
            <br/>014001 - FOOD PRODUCTS AND TECHNOLOGY
            <br/>016004 - WELDING
            <br/>016005 - METALS AND FABRICATION
            <br/>020600 - PHOTOGRAPHY
            <br/>020700 - INTERNATIONAL BACCALAUREATE ® (IB)-VISUAL ARTS
            <br/>020702 - VISUAL ARTS-INDEPENDENT STUDY
            <br/>030302 - COLLEGE PRINCIPLES OF ACCOUNTING
            <br/>030303 - COLLEGE PRINCIPLES OF ACCOUNTING II
            <br/>030502 - ACCOUNTING 2
            <br/>030503 - ACCOUNTING 3
            <br/>030504 - ACCOUNTING 4
            <br/>030600 - BUSINESS COMMUNICATION
            <br/>031800 - ECONOMICS
            <br/>032300 - INTRODUCTION TO BUSINESS
            <br/>032370 - ENTREPRENEURSHIP
            <br/>032802 - MANAGEMENT AND LEADERSHIP
            <br/>033000 - PERSONAL FINANCE
            <br/>033002 - WEALTH BUILDING FUNDAMENTALS
            <br/>038100 - MARKETING
            <br/>038101 - MARKETING MANAGEMENT
            <br/>038200 - ADVANCED MARKETING
            <br/>077200 - MIDDLE SCHOOL EXPLORATION OF HEALTH SCIENCES
            <br/>077300 - HEALTH SCIENCES I
            <br/>077301 - HEALTH SCIENCES II
            <br/>077302 - HEALTH SCIENCES III
            <br/>077500 - INTRODUCTION TO SPORTS MEDICINE
            <br/>077600 - MEDICAL TERMINOLOGY
            <br/>077801 - BEHAVIORAL HEALTH I
            <br/>077802 - BEHAVIORAL HEALTH II
            <br/>080105 - HEALTH, SPECIALIZED
            <br/>080116 - INTRODUCTION TO DANCE
            <br/>080119 - DANCE PERFORMANCE
            <br/>080128 - MIDDLE SCHOOL PHYSICAL EDUCATION, OTHER
            <br/>089930- 089932 - PHYSICAL EDUCATION, OTHER
            <br/>090005 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 6
            <br/>090006 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 7
            <br/>090007 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 8
            <br/>090101 - INTRODUCTION TO FAMILY AND CONSUMER SCIENCES
            <br/>090104 - LIFE AND CAREER READINESS
            <br/>090113 - FOOD SCIENCE
            <br/>090116 - INTERPERSONAL RELATIONSHIPS
            <br/>090117 - PARENTS AND FAMILIES
            <br/>090119 - CHILD DEVELOPMENT
            <br/>090124 - NUTRITION
            <br/>090127 - FAMILIES IN CRISIS
            <br/>090128 - CAREERS IN MENTAL HEALTH
            <br/>090206 - FASHION DESIGN
            <br/>100100 - INTRODUCTION TO SKILLED AND TECHNICAL SCIENCES
            <br/>100110 - CONSTRUCTION TRADES 1
            <br/>100120 - CONSTRUCTION TRADES 2
            <br/>100130 - DRAFTING AND DESIGN
            <br/>100140 - ARCHITECTURAL DESIGN 1
            <br/>100141 - ARCHITECTURAL DESIGN 2
            <br/>100401 - INTRODUCTION TO ELECTRONICS
            <br/>100402 - ADVANCED ELECTRONICS
            <br/>100407 - PHYSICS AND MATHEMATICS OF ENERGY
            <br/>100706 - MIDDLE SCHOOL EXPLORING SKILLED AND TECHNICAL SCIENCES - 6TH
            <br/>100707 - MIDDLE SCHOOL EXPLORING SKILLED AND TECHNICAL SCIENCE - 7TH
            <br/>100708 - MIDDLE SCHOOL EXPLORING SKILLED AND TECHNICAL SCIENCE - 8TH
            <br/>101401 - MANUFACTURING PRODUCTION - METALS
            <br/>101402 - ADVANCED MANUFACTURING & FABRICATION – METALS
            <br/>100403 - PLTW DIGITAL ELECTRONICS
            <br/>100408 - SUSTAINABLE ENERGY
            <br/>101400 - MANUFACTURING PROCESS – METALS
            <br/>101600 - TRANSPORTATION 1
            <br/>101601 - INTRO TO TRANSPORTATION, DISTRIBUTION, AND LOGISTICS
            <br/>101610 - DISTRIBUTION AND LOGISTICS
            <br/>101620 - TRANSPORTATION 2
            <br/>101630 - TRANSPORTATION 3
            <br/>101640 - COLLISON REPAIR
            <br/>101650 - BUSINESS LOGISTICS
            <br/>101900 - INTRODUCTION TO MECHATRONICS
            <br/>101901 - PLTW COMPUTER INTEGRATED MANUFACTURING
            <br/>101920 - MANUFACTURING PROCESSES - WOODS
            <br/>101921 - MANUFACTURING PRODUCTION - WOODS
            <br/>101922 - ADVANCED MANUFACTURING & FABRICATION - WOODS
            <br/>101930 - WELDING 1
            <br/>101940 - WELDING 2
            <br/>101941 - WELDING 3
            <br/>101950 - MANUFACTURING PROCESSES - PLASTICS
            <br/>101951 - MANUFACTURING PRODUCTION - PLASTICS
            <br/>101952 - ADVANCED MANUFACTURING & FABRICATION - PLASTICS
            <br/>103191 - ENGINEERING DESIGN AND SYSTEMS THINKING
            <br/>103192 - ENGINEERING PROBLEM SOLVING
            <br/>103193 - SYSTEMS ENGINEERING AND PROJECT MANAGEMENT
            <br/>103194 - ROBOTICS
            <br/>103195 - ADVANCED ROBOTICS
            <br/>120700 - ADVANCED PLACEMENT MUSIC THEORY
            <br/>129930-129934 - MUSIC, OTHER
            <br/>229930 - THEATRE, OTHER
            <br/>260200 - ADOLESCENT DEVELOPMENT
            <br/>359930-359934 - EDUCATION AND TRAINING, OTHER
            <br/>370021 - CULINARY SKILLS 1
            <br/>370022 - CULINARY SKILLS 2
            <br/>370030 - PROSTART 1
            <br/>370031 - PROSTART 2
            <br/>379930-379934 - HOSPITALITY AND TOURISM, OTHER
            <br/>390010 - FOUNDATIONS OF LAW, PUBLIC SAFETY, CORRECTIONS & SECURITY
            <br/>390015 - INTRODUCTION TO CRIMINAL JUSTICE
            <br/>390025 - COURTS & JUDICIAL PROCESS
            <br/>390026 - POLICE AND SOCIETY <br/>
            </p>
            <br />
            {/* <p><strong>{++changenum}. Course Codes with Description Changes and Endorsements Added</strong></p>
            <p className="changelist">
                320100 - MIDDLE SCHOOL CAREER DEVELOPMENT added 0700 (HEALTH SCIENCES EDUCATION) and 2908 (HEALTH SCIENCE)<br />  
                359930 through 359934 - EDUCATION AND TRAINING, OTHER added 0903 (FAMLY/CONSMR SCIENCE)<br />  
            </p>
            <br /> */}
            <p><strong>{++changenum}. Endorsement codes have been ADDED for the following course codes</strong></p>
            <p className="changelist">
            050050 - ADVANCED PLACEMENT ENGLISH LANG/COMP (SECONDARY ENGLISH)
            <br/>050051 - ADVANCED PLACEMENT ENGLISH LIT/COMP (SECONDARY ENGLISH)
            <br/>050052 - IB LANGUAGE A - (ENGLISH) added 0512 (SECONDARY ENGLISH) and 0508 (READING SPECIALIST)
            <br/>050053 - IB LANGUAGE A (ENGLISH) MIDDLE YEARS PROGRAM added 0508 and 1817 (MIDDLE LVL/ELA)
            <br/>050063 - LITERATURE OF A GENRE added 0512 (SECONDARY ENGLISH)
            <br/>050300 - LITERATURE, GENERAL added 0512 (SECONDARY ENGLISH)
            <br/>050301- AMERICAN LITERATURE added 0512 (SECONDARY ENGLISH)
            <br/>050304 - BRITISH LITERATURE added 0512 (SECONDARY ENGLISH)
            <br/>050310 - LITERATURE, SPECIALIZED added 0512 (SECONDARY ENGLISH)
            <br/>050506 - APPLIED COMMUNICATIONS added 0508 (READING SPECIALIST)
            <br/>059931- 059934 - ENGLISH LANGUAGE ARTS, OTHER added 0512 (SECONDARY ENGLISH)
            <br/>090122 - EARLY CHILDHOOD EDUCATION PRACTICUM WITH WORK-BASED LEARNING added 1605 (WORK-BASED LEARNING)
            <br/>099935 - MIDDLE SCHOOL FCS/HUMAN SERVICES, OTHER added 1813 (MIDDLE LVL/FAMILY & CONSUMER)
            <br/>270410 - MIDDLE SCHOOL INTRODUCTION TO COMPUTER SCIENCE & WEB DESIGN added 1100 (MATHEMATICS)
            <br/>270411 - MIDDLE SCHOOL INTRODUCTION TO COMPUTER SCIENCE added 1100 (MATHEMATICS)
            <br/>270611 - DIGITAL DESIGN added 0510 JOURNALISM AND MASS COMMUNICATION and 0520 JOURNALISM AND MEDIA EDUCATION  <br/>
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been REMOVED for the following course codes</strong></p>
            <p className="changelist">
            <br/>019930 - 019934 - AGRICULTURE, FOOD AND NATURAL RESOURCES, OTHER removed 0905 (HORT EDUC)
            <br/>020100 - VISUAL ARTS I removed 0201 (GENERAL ART)
            <br/>020200 - VISUAL ARTS II removed 1811 (MIDDLE LVL/ART)
            <br/>020800 - ART-MIDDLE SCHOOL/JUNIOR HIGH I removed 0201 (GENERAL ART)
            <br/>020801 - ART-MIDDLE SCHOOL/JUNIOR HIGH II removed 0201 (GENERAL ART)
            <br/>020802 - ART-SCHOOL GRADES/JUNIOR HIGH III removed 0201 (GENERAL ART)
            <br/>029930-029934 - VISUAL ARTS, OTHER removed 0201 (GENERAL ART)
            <br/>120100 - MUSIC - GENERAL removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120550 - SMALL ENSEMBLE INSTRUMENTAL removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120650 - INDIVIDUAL INSTRUCTION/INSTRUMENTAL removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120700 - ADVANCED PLACEMENT MUSIC THEORY removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120800 - IB-MUSIC removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120801 - INTERDISCIPLINARY ARTS-MUSIC removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120802 - MUSIC-INDEPENDENT STUDY removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120804 - MUSIC THEORY removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120805 - MUSIC TECHNOLOGY/ELECTRONIC removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120806 - CULTURALLY INFLUENCED ENSEMBLE removed 1202 (INSTRUMENTAL MUSIC)
            <br/>120807 - MUSIC COMPOSITION/SONGWRITING removed 1202 (INSTRUMENTAL MUSIC)
            <br/>129930-129934 - MUSIC, OTHER removed 1202 (INSTRUMENTAL MUSIC)
            <br/>191215 - SPECIAL EDUCATION MUSIC-K-12 (PAC 1161) removed 1202 (INSTRUMENTAL MUSIC)
            <br/>191230 - SPECIAL EDUCATION MUSIC (PAC 1162) removed 1202 (INSTRUMENTAL MUSIC)
            <br/>220200 - THEATRE-ACTING/PERFORMANCE removed 0504 (SPEECH AND THEATRE)
            <br/>220300 - THEATRE-STAGECRAFT removed 0504 (SPEECH AND THEATRE)
            <br/>220400 - THEATRE-DIRECTING removed 0504 (SPEECH AND THEATRE)
            <br/>220500 - THEATRICAL PRODUCTION AND MANAGEMENT removed 0504 (SPEECH AND THEATRE)
            <br/>220700 - IB-THEATRE removed 0504 (SPEECH AND THEATRE)
            <br/>220701 - INTERDISCIPLINARY ARTS-THEATRE removed 0504 (SPEECH AND THEATRE)
            <br/>220702 - THEATRE-INDEPENDENT STUDY removed 0504 (SPEECH AND THEATRE)
            <br/>229930 - THEATRE, OTHER removed 0504 (SPEECH AND THEATRE)
            <br/>270401 - PROGRAMMING I removed 2903 (COMMUNICATIONS ARTS)
            <br/>270402 - PROGRAMMING II removed 2903 (COMMUNICATIONS ARTS)
            <br/>270403 - PROGRAMMING III removed 2903 (COMMUNICATIONS ARTS)
            <br/>270501 - INFORMATION TECHNOLOGY APPLICATIONS I removed 2903 (COMMUNICATIONS ARTS)
            <br/>270502 - INFORMATION TECHNOLOGY APPLICATIONS II removed 2903 (COMMUNICATIONS ARTS)
            <br/>270504 - INFORMATION TECHNOLOGY FUNDAMENTALS removed 2903 (COMMUNICATIONS ARTS)
            <br/>270601 - NETWORKING removed 2903 (COMMUNICATIONS ARTS)
            <br/>270602 - DIGITAL MEDIA removed 2903 (COMMUNICATIONS ARTS)
            <br/>270604 - FOUNDATIONS OF WEB DESIGN removed 2903 (COMMUNICATIONS ARTS)
            <br/>270606 - PC SUPPORT AND MAINTENANCE removed 2903 (COMMUNICATIONS ARTS)
            <br/>270607 - INFORMATION TECHNOLOGY SUPPORT removed 2903 (COMMUNICATIONS ARTS)
            <br/>270608 - INTRODUCTION TO MEDIA removed 2903 (COMMUNICATIONS ARTS)
            <br/>270609 - VIDEO PRODUCTION removed 2903 (COMMUNICATIONS ARTS)
            <br/>270610 - MEDIA PRODUCTION removed 2903 (COMMUNICATIONS ARTS)
            <br/>270611 - DIGITAL DESIGN removed 2903 (COMMUNICATIONS ARTS)
            <br/>270613 - ADVANCED DIGITAL DESIGN removed 2903 (COMMUNICATIONS ARTS)
            <br/>270700 - ADVANCED PLACEMENT COMPUTER SCIENCE A removed 2903 (COMMUNICATIONS ARTS)
            <br/>279930- 279934 - COMMUNICATION AND INFORMATION SYSTEMS, OTHER removed 2903 (COMMUNICATIONS ARTS)  <br/>
            </p>
            <br />
            <br />
            <br />
            <p className="title is-4">
                <strong>Version 13.0.0</strong>
                <br />
                <strong>April 15, 2022</strong>
            </p>
            <p><strong>{changenum=1}. Subject Update</strong></p>
            <p className="changelist">
                HUMAN SERVICES/FACS (09) updated to HUMAN SERVICES/FCS (09)<br />
            </p>
            <br />
            <p><strong>{++changenum}. New Course Codes</strong></p>
            <p className="changelist">
                080128 - MIDDLE SCHOOL PHYSICAL EDUCATION, OTHER<br />
                099935 - MIDDLE SCHOOL HUMAN SERVICES/FCS, OTHER <br />                
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes Removed</strong></p>
            <p className="changelist">
                018080 - FNS - FOOD PRODUCTION, NUTRITION, AND HEALTH<br />
                018081 - FNS - FOOD SCIENCE<br />
                018082 - FNS - NUTRITION SCIENCE<br />
                077933 - HEALTH SCIENCES, OTHER<br /> 
                077934 - HEALTH SCIENCES, OTHER<br /> 
                080100 - HEALTH I<br /> 
                080101 - HEALTH II<br /> 
                080106 - FAMILY HEALTH<br /> 
                080127 - ADAPTIVE PHYSICAL EDUCATION<br />
                090129 - FNS - FOOD PRODUCTION, NUTRITION AND HEALTH<br /> 
                090130 - FNS - FOOD SCIENCE<br /> 
                090131 - FNS - NUTRITION SCIENCE<br /> 
            </p>
            <br />            
            <p><strong>{++changenum}. Course Codes with Name Changes</strong></p>
            <p className="changelist">
                011012 - MIDDLE SCHOOL AG, FOOD & NATURAL RESOURCES (previously MS INTRODUCTION TO AG, FOOD & NATURAL RESOURCES)<br />                
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Name and Description Changes</strong></p>
            <p className="changelist">
                018002 - MIDDLE SCHOOL CAREERS AND LITERACY OF AGRICULTURE (previously CAREERS AND LITERACY OF AGRICULTURE)<br />  
                019930 through 019934 - MIDDLE SCHOOL AGRICULTURE, FOOD AND NATURAL RESOURCES, OTHER (previously AGRICULTURE, FOOD AND NATURAL RESOURCES, OTHER)<br /> 
                020800 - ART-MIDDLE SCHOOL/JUNIOR HIGH I (previously ART-MIDDLE GRADES/JUNIOR HIGH I)<br /> 
                020801 - ART-MIDDLE SCHOOL /JUNIOR HIGH II (previously ART-MIDDLE GRADES/JUNIOR HIGH II)<br />  
                020802 - ART-MIDDLE SCHOOL /JUNIOR HIGH III (previously ART-MIDDLE GRADES/JUNIOR HIGH III)<br />  
                032350 - MIDDLE SCHOOL EXPLORATION OF BUSINESS AND ENTREPRENEURSHIP (previously EXPLORATION OF BUSINESS AND ENTREPRENEURSHIP)<br /> 
                033422 - MIDDLE SCHOOL INTRODUCTION TO BUSINESS TECHNOLOGY (previously INTRODUCTION TO BUSINESS TECHNOLOGY)<br />  
                033501 - MIDDLE SCHOOL KEYBOARDING APPLICATIONS (previously KEYBOARDING APPLICATIONS)<br />  
                050800 - MIDDLE SCHOOL READING I (previously READING-MIDDLE GRADES/JUNIOR HIGH I)<br />  
                050801 - MIDDLE SCHOOL READING II (previously READING-MIDDLE GRADES/JUNIOR HIGH II)<br />  
                050802 - MIDDLE SCHOOL LANGUAGE ARTS I (previously LANGUAGE ARTS-MIDDLE GRADES/JUNIOR HIGH I)<br />  
                050803 - MIDDLE SCHOOL LANGUAGE ARTS II (previously LANGUAGE ARTS-MIDDLE GRADES/JUNIOR HIGH II)<br />  
                050804 - MIDDLE SCHOOL LANGUAGE ARTS III (previously LANGUAGE ARTS-MIDDLE GRADES/JUNIOR HIGH III)<br />  
                077200 - MIDDLE SCHOOL EXPLORATION OF HEALTH SCIENCES (previously EXPLORATION OF HEALTH SCIENCES)<br />  
                080103 - ADVANCED HEALTH (previously FUNDAMENTALS OF COMMUNITY AND PUBLIC HEALTH)<br />  
                080125 - ELEMENTARY PHYSICAL EDUCATION (previously PHYSICAL EDUCATION ELEMENTARY)<br />  
                080126 - MIDDLE SCHOOL PHYSICAL EDUCATION (previously PHYSICAL EDUCATION MIDDLE SCHOOL)<br />  
                090005 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 6 (previously FAMILY AND CONSUMER SCIENCES 6)<br />  
                090006 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 7 (previously FAMILY AND CONSUMER SCIENCES 7)<br />  
                090007 - MIDDLE SCHOOL FAMILY AND CONSUMER SCIENCES 8 (previously FAMILY AND CONSUMER SCIENCES 8)<br />  
                090101 - INTRODUCTION TO FAMILY AND CONSUMER SCIENCES (previously INTRODUCTION TO HUMAN SCIENCE/FACS)<br />  
                099930 through 099934 - HUMAN SERVICES/FCS, OTHER (previously HUMAN SERVICES/FACS, OTHER)<br />  
                100706 - MIDDLE SCHOOL EXPLORING SKILLED AND TECHNICAL SCIENCES – 6TH (previously EXPLORING SKILLED AND TECHNICAL SCIENCE - 6TH GRADE)<br />  
                100707 MIDDLE SCHOOL EXPLORING SKILLED AND TECHNICAL SCIENCE – 7TH (previously EXPLORING SKILLED AND TECHNICAL SCIENCE - 7TH GRADE)<br />  
                100708 - MIDDLE SCHOOL EXPLORING SKILLED AND TECHNICAL SCIENCE – 8TH (previously EXPLORING SKILLED AND TECHNICAL SCIENCE - 8TH GRADE)<br />  
                112800 - MATHEMATICS-MIDDLE SCHOOL/JR HIGH I (previously MATHEMATICS-MIDDLE GRADES/JR HIGH I)<br />  
                112801 - MATHEMATICS-MIDDLE SCHOOL /JR HIGH II (previously MATHEMATICS-MIDDLE GRADES/JR HIGH II)<br />  
                112802 - MATHEMATICS-MIDDLE SCHOOL /JR HIGH III (previously MATHEMATICS-MIDDLE GRADES/JR HIGH III)<br />  
                130801 - MIDDLE SCHOOL SCIENCE I (previously SCIENCE-MIDDLE GRADES/JR HIGH I)<br />
                130802 - MIDDLE SCHOOL SCIENCE II (previously SCIENCE-MIDDLE GRADES/JR HIGH II)<br />  
                130803 - MIDDLE SCHOOL SCIENCE III (previously SCIENCE-MIDDLE GRADES/JR HIGH III)<br />  
                193000 - SPECIAL EDUCATION, ADAPTED PHYSICAL EDUCATION (previously PHYSICAL EDUCATION, ADAPTIVE)<br />  
                270410 - MIDDLE SCHOOL INTRODUCTION TO COMPUTER SCIENCE & WEB DESIGN (previously INTRODUCTION TO COMPUTER SCIENCE & WEB DESIGN)<br />  
                270411 - MIDDLE SCHOOL INTRODUCTION TO COMPUTER SCIENCE (previously INTRODUCTION TO COMPUTER SCIENCE)<br />  
                270412 - MIDDLE SCHOOL INTRODUCTION TO WEB DESIGN (previously INTRODUCTION TO WEB DESIGN)<br />  
                310050 - ELEMENTARY-MULTILINGUAL OR DUAL LANGUAGE ARTS (previously ESL OR DUAL LANGUAGE ARTS-ELEMENTARY)<br />  
                310051 - SECONDARY MULTILINGUAL OR DUAL LANGUAGE ARTS (previously ESL OR DUAL LANGUAGE ARTS-SECONDARY)<br />  
                310010 - MULTILINGUAL LEARNERS (previously ENGLISH AS A SECOND LANGUAGE)<br />  
                310101 - MULTILINGUAL/DUAL LANGUAGE (previously BILINGUAL/ENGLISH AS A DUAL LANGUAGE)<br />  
                310110 - ELEMENTARY MULTILINGUAL LEARNERS MATH (previously ESL OR DUAL LANGUAGE MATHEMATICS-ELEMENTARY)<br /> 
                310111 - SECONDARY MULTILINGUAL LEARNERS MATH (previously ESL OR DUAL LANGUAGE MATHEMATICS-SECONDARY)<br />  
                310130 - ELEMENTARY MULTILINGUAL LEARNERS SCIENCE (previously ESL OR DUAL LANGUAGE SCIENCE-ELEMENTARY)<br />  
                310131 - SECONDARY MULTILINGUAL LEARNERS SCIENCE (previously ESL OR DUAL LANGUAGE SCIENCE-SECONDARY)<br />  
                310150 - ELEMENTARY MULTILINGUAL LEARNERS SOCIAL STUDIES (previously ESL OR DUAL LANGUAGE SOCIAL STUDIES-ELEMENTARY)<br />  
                310151 - SECONDARY MULTILINGUAL LEARNERS SOCIAL STUDIES (previously ESL OR DUAL LANGUAGE SOCIAL STUDIES-SECONDARY)<br />
                320704 - COMMUNICATION ARTS WORK-BASED LEARNING EXPERIENCE (previously ARTS, AV & COM WORK-BASED LEARNING EXPERIENCE)<br />
                320712 - HUMAN SERVICES/FCS WORK-BASED LEARNING EXPERIENCE (previously HUMAN SERVICES/FACS WORK-BASED LEARNING EXPERIENCE) <br />
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Name Change and Endorsements Added</strong></p>
            <p className="changelist">
                320300 - MIDDLE SCHOOL ENGAGE! CAREER EXPLORATION AND READINESS (previously ENGAGE! CAREER EXPLORATION AND READINESS) added 0700 (HEALTH SCIENCES EDUCATION) and 2908 (HEALTH SCIENCE)<br /> 
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Description Changes</strong></p>
            <p className="changelist">
                080105 - HEALTH, SPECIALIZED<br /> 
                300100 - HIGH ABILITY EDUCATION (OTHER)<br /> 
                300101 - HIGH ABILITY LEARNING (ELEMENTARY)<br /> 
                300102 - HIGH ABILITY LEARNING (SECONDARY)<br /> 
                399930 through 399934 - LAW, PUBLIC SAFETY AND SECURITY, OTHER<br /> 
                320702 - AFNR WORK-BASED LEARNING EXPERIENCE<br /> 
                320703 - ARCH & CONST WORK-BASED LEARNING EXPERIENCE<br />                
                320705 - BUSINESS MGMT WORK-BASED LEARNING EXPERIENCE<br /> 
                320706 - ED & TRAIN WORK-BASED LEARNING EXPERIENCE<br /> 
                320707 - ENERGY & ENG WORK-BASED LEARNING EXPERIENCE<br /> 
                320708 - FINANCE WORK-BASED LEARNING EXPERIENCE<br /> 
                320710 - HEALTH SCIENCE WORK-BASED LEARNING EXPERIENCE<br /> 
                320711 - HOSPITALITY & TOURISM WORK-BASED LEARNING EXPERIENCE<br />                
                320713 - INFORMATION TECHNOLOGY WORK-BASED LEARNING EXPERIENCE<br /> 
                320714 - LAW, PUBLIC SAFETY WORK-BASED LEARNING EXPERIENCE<br /> 
                320715 - MANUFACTURING WORK-BASED LEARNING EXPERIENCE<br /> 
                320716 - MARKETING WORK-BASED LEARNING EXPERIENCE<br /> 
                320717 - TRANSPORTATION WORK-BASED LEARNING EXPERIENCE<br />  
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Description Changes and Endorsements Added</strong></p>
            <p className="changelist">
                320100 - MIDDLE SCHOOL CAREER DEVELOPMENT added 0700 (HEALTH SCIENCES EDUCATION) and 2908 (HEALTH SCIENCE)<br />  
                359930 through 359934 - EDUCATION AND TRAINING, OTHER added 0903 (FAMLY/CONSMR SCIENCE)<br />  
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been ADDED for the following course codes</strong></p>
            <p className="changelist">
                320101 – HIGH SCHOOL CAREER DEVELOPMENT - added 0700 (HEALTH SCIENCES EDUCATION) and 2908 (HEALTH SCIENCE)<br />  
                329930 through 329934 – CAREER ED FOUNDATIONAL & SPECIALTY, OTHER - added 0700 (HEALTH SCIENCES EDUCATION) and 2908 (HEALTH SCIENCE)<br />  
                193000 - SPECIAL EDUCATION, ADAPTED PHYSICAL EDUCATION – added 1913 SPECIAL EDUCATION GENERALIST)<br />  
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been REMOVED for the following course codes</strong></p>
            <p className="changelist">
                101402 - ADVANCED MANUFACTURING & FABRICATION – METALS - removed 1704 (T&I METALS)<br />  
                101941 - WELDING 3 - removed 1704 (T&I METALS)<br />   
                270608 - INTRODUCTION TO MEDIA - removed 0522 (SPEECH 0522)<br />  
                270609 - VIDEO PRODUCTION - removed 0522 (SPEECH 0522)<br />  
                270610 - MEDIA PRODUCTION - removed 0522 (SPEECH 0522)<br />  
            </p>
            <br />
            <br />
            <br />
            <p className="title is-4">
                <strong>Version 12.0.0</strong>
                <br />
                <strong>February 23, 2021</strong>
            </p>

            <p><strong>{changenum=1}. New Course Codes</strong></p>
            <p className="changelist">
                080102 – Foundations of Health Education<br />
                080103 – Fundamentals of Community and Public Health<br />
                080104 – Middle School Health Education<br />
                300101 – High Ability Learning (Elementary)<br />
                300102 – High Ability Learning (Secondary)<br />
            </p>
            <br />

            <p><strong>{++changenum}. Course Codes Removed</strong></p>
            <p className="changelist">
                090300 – Family and Consumer Science 6<br />
                150011 – Social Studies - Middle Grades/Jr High I<br />
                150012 – Social Studies - Middle Grades Jr High II<br />
                150013 – Social Studies - Middle Grades/ Jr High III<br />
                250101 – Title I Reading <br />
                250102 – Title I Mathematics <br />
                250103 – Title I Extended Kindergarten<br />
                250104 – Title I Language Arts<br />
                250105 – Title I Prekindergarten<br />
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Name Change and Endorsements Added</strong></p>
            <p className="changelist">
                300100 – High Ability Education (Other). Previous name: High Ability Education <br />
                &nbsp;&nbsp;&nbsp;Add endorsement code – 1604 – Gifted Endorsement
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Description Changes</strong></p>
            <p className="changelist">
                080100 – Health I<br />
                080101 – Health II<br />
                080106 – Family Health<br />
                290101 – Supplemental Reading<br />
                290102 – Supplemental Math<br />
            </p>
            <br />
            <p><strong>{++changenum}. Course Codes with Description Changes and Endorsements Added</strong></p>
            <p className="changelist">
                080105 – Health, Specialized – added 0903 – Family/Consmr Science
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been ADDED for the following course codes</strong></p>
            <p className="changelist">
                350001 – Introduction to Education and Training - added 0903 – Family/Consmr Science<br />
                350002 – Best Practices to Education and Training – added 0903 – Family/Consmr Science<br />
                350010 – Field Experience in Education and Training - added 0903 – Family/Consmr Science<br />
            </p>
            <br />
            <p><strong>{++changenum}. Endorsement codes have been REMOVED for the following course codes</strong></p>
            <p className="changelist">
                090103 – Textile Construction – removed 2910 – Human Services<br />
                090104 – Life and Career Readiness - removed 2910 – Human Services<br />
                090107 – Fundamentals of Food and Nutrition - removed 2910 – Human Services<br />
                090109 – Home Design and Interiors - removed 2910 – Human Services<br />
                090113 – Food Science - removed 2910 – Human Services<br />
                090117 – Parents and Families - removed 2910 – Human Services<br />
                090119 – Child Development - removed 2910 – Human Services<br />
                090206 – Fashion Design - removed 2910 – Human Services<br />
                090207 – The Business of Textiles - removed 2910 – Human Services<br />
                090208 – Leadership and Ethics in Human Services - removed 2910 – Human Services<br />
                090209 – Consumer Economics - removed 2910 – Human Services<br />
                099930 – 099934 – Human Services/FACS, Other - removed 2910 – Human Services<br />
                370010 – Hospitality and Tourism – removed 2909 – Hospitality & Tourism<br />
                370021 – Culinary Skills 1 - removed 2909 – Hospitality & Tourism<br />
                370022 – Culinary Skills 2 - removed 2909 – Hospitality & Tourism<br />
                370030 – ProStart 1 - removed 2909 – Hospitality & Tourism<br />
                370031 – ProStart 2 - removed 2909 – Hospitality & Tourism<br />
                379930 – 379934 – Hospitality and Tourism, Other – removed 2909 – Hospitality & Tourism
            </p>

            <br />
            <br />
            <br />
            <p>
                <strong>Version 11.0.0</strong>
                <br />
                <strong>April 6, 2020</strong>
            </p>
            <br />
            <p><strong>1. New Course Codes</strong></p>
            <p className="changelist">
            033005 – IB Business Management<br />
            033006 – IB Economics<br />
            060260 – Spanish For Native Speakers III<br />
            150014 – 6th Grade World Studies I<br />
            150015 – 7th Grade World Studies II<br />
            150016 – 8th Grade United States History<br />
            </p>
            <p>
                <strong>2. Course Codes Removed</strong></p>
            <p className="changelist">
            030300 – Accounting<br />
            030301 – Accounting, Advanced<br />
            3. Course Codes with Name and Description Changes<br />
            150700 – High School Geography (previous name: Geography)<br />
            150800 ‐ High School World History (previous name: World History)<br />
            150820 – High School US History (previous name: American History)<br />
            151000 – High School Economics (previous name: Economics)<br />
            151114 – High School Civics (previous name: Civics)<br />
            </p>
            <p>
                <strong>4. Course Codes with Description Changes</strong></p>
            <p className="changelist">
            150011 – Social Studies – Middle Grades/Jr High I<br />
            150012 – Social Studies – Middle Grades/Jr High II<br />
            150013 – Social Studies – Middle Grades/Jr High III<br />
            151200 – Psychology<br />
            151300 – Sociology<br />
            </p>
            <p>
                <strong>5. Endorsement codes have been ADDED for the following course codes</strong></p>
            <p className="changelist">
            050100 – Creative Writing/Composition – added 0512<br />
            </p>
            <br />


            <br />
            <p>
                <strong>Version 10.0.0</strong>
                <br />
                <strong>April 12, 2019</strong>
            </p>
            <br />
            <p>
                <strong>1. New Course Codes</strong></p>
            <p className="changelist">
                020700 – IB‐Visual Arts<br />
                020701 – Interdisciplinary Arts‐Visual Arts<br />
                020702 – Visual Arts‐Independent Study<br />
                020703‐ Visual Arts‐Work Based Learning<br />
                030501 – Accounting I<br />
                030502 – Accounting 2<br />
                030503 – Accounting 3<br />
                030504 – Accounting 4<br />
                120800 – IB‐Music<br />
                120801 – Interdisciplinary Arts‐Music<br />
                120802 – Music‐Independent Study<br />
                120803 – Music‐Work Based Learning<br />
                120804 – Music Theory Fundamentals<br />
                120805 – Music Technology/Electronic<br />
                120806 – Music Cultural Ensembles<br />
                120807 – Music Composition/Songwriting<br />
                130203 – Environmental Science<br />
                130204 – AP Environmental Science<br />
                130205 – Energy and Environment<br />
                191615 – Special Education Work Experience 9‐12 (PAC 1161)<br />
                161630 – Special Education Work Experience (PAC 1162)<br />
                220200 – Theatre‐Acting/Performance<br />
                220300 – Theatre‐Stagecraft<br />
                220400 – Theatre‐Directing<br />
                220500 – Theatrical Production and Management<br />
                220700 – IB‐Theatre<br />
                220701 – Interdisciplinary Arts‐Theatre<br />
                220702 – Theatre‐Independent Study<br />
                220703 – Theatre Work Based Learning<br />
                229930 – Theatre, Other<br />
            </p>
            <br />
            <p>
                <strong>2. Course Codes with Name Changes only</strong></p>
            <p className="changelist">
            230803 – Non‐Graded Study Hall (previous name: Study Hall) <br />
            </p>
            <br />
            <p>
                <strong>3. Course Codes with Name and Description Changes</strong></p>
            <p className="changelist">
            031800 – Economics (previous name:  Business Economics)<br />
            032300 – Introduction To Business (previous name: Introduction to Business, Marketing & Mgt)<br />
            033002 – Wealth Building Fundamentals (previous name: College Wealth Building & Financial Management)<br />
            4. Course Description changes<br />
            030900 – Business Law<br />
            032350 – Exploration of Business and Entrepreneurship<br />
            032370 – Entrepreneurship<br />
            032802 – Management and Leadership<br />
            033000 – Personal Finance<br />
            038100 – Marketing<br />
            038101 ‐  Marketing Management<br />
            038200 – Advanced Marketing<br />
            130420 – Physical Science – Integrated<br />
            130422 – Biology – Integrated<br />
            130423 – Chemistry – Integrated<br />
            151300 – Sociology<br />
            190215 – Special Education Art K‐12 (PAC 1161)<br />
            190230 – Special Education Art (PAC 1162)<br />
            190515 – Special Education Language Arts   K‐12 (PAC 1161)<br />
            190530 – Special Education Language Arts (PAC 1162)<br />
            191115 – Special Education Mathematics  K‐12 (PAC 1161)<br />
            191130 – Special Education Mathematics  (PAC 1162)<br />
            191215 – Special Education Music   K‐12 (PAC 1161)<br />
            191230 – Special Education Music (PAC 1162)<br />
            191315 – Special Education Science   K‐12  (PAC 1161)<br />
            131330 – Special Education Science  (PAC 1162)<br />
            191515 – Special Education Social Studies   K‐12  (PAC 1161)<br />
            191530 – Special Education Social Studies  (PAC 1162)<br />
            192000 – Special Ed Functional Skills and Activities  (PAC 1162)<br />
            192015 – Special Education Independent Living  K‐12  (PAC 1161)<br />
            320700 – Other Work‐Based Learning Class<br />
            320701 – Other Work‐Based Learning Experience<br />
            </p>
            <br />
            <p>
                <strong>5. Endorsement codes have been ADDED/REMOVED for the following course codes</strong></p>
            <p className="changelist">
            013000 – Environmental And Natural Resources – Add 1301<br />
            018065 – Case Food Science and Safety – Add 0903<br />
            018080 – FNS – Food Production, Nutrition, And Health – Add 0903<br />
            018081 – FNS – Food Science – Add 0903<br />
            018082 – FNS – Nutrition Science – Add 0903<br />
            </p>
        </div>
    );
};

export default Changes;
